/* eslint-disable */
import React, { useState, useEffect, useReducer, useRef, useContext } from 'react';
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import { Col, notification, Row } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Prelist, ChoosenTotals } from './components';
import { userVar } from 'graphql/cache';
import {
  CONTENT_LIBRARY_ADD_CATALOG,
  CONTENT_LIBRARY_ADD_CHILD,
  CONTENT_LIBRARY_UPDATE_CATALOG,
} from 'graphql/mutations/contentLibraryMutations';
import { GET_TREEVIEW_DATA } from 'graphql/queries/contentLibraryQueries';
import { ContentLibraryProvider } from 'context/ContentLibraryContext';
import { handleTreeSearch, filterTreeData, handleModalTreeSearch } from 'helpers/contentlibrary';
import Loader from 'components/Loader';

import helpers from 'helpers/proposal';
import DraftContext from 'context/DraftContext';
import useTreeHandler from 'hooks/treeHandler';

import './Tablist.scss';

const initialState = {
  chosen: '',
  stab: '',
  optionsDropdown: false,
  selectedValue: null,
  totalValue: 0,
  optionsDeleteModal: false,
  collapse: false,
  showSaveDeliverableModal: false,
  selectedFolder: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'setChosen':
      return { ...state, chosen: typeof action.chosen === 'string' ? {} : action.chosen };
    case 'setStab':
      if (action.reset) {
        const tempState = JSON.parse(JSON.stringify(state));
        if (Object.keys(tempState.chosen).length > 0) {
          const chosenData = tempState.chosen[action.stab];
          if (chosenData.discount) {
            chosenData.discount.val = 0;
          }
          if (chosenData.tax) {
            chosenData.tax.val = 0;
          }
          (tempState.chosen[action.stab] = chosenData), (tempState.stab = action.stab);
        }
        return tempState;
      } else {
        return { ...state, stab: action.stab };
      }
    case 'setOptionsDropdown':
      return { ...state, optionsDropdown: action.optionsDropdown };
    case 'setSelectedValue':
      return { ...state, selectedValue: action.selectedValue };
    case 'setTotalValue':
      return { ...state, totalValue: action.totalValue };
    case 'setOptionsDeleteModal':
      return { ...state, optionsDeleteModal: action.optionsDeleteModal };
    case 'setCollapse':
      return { ...state, collapse: action.collapse };
    case 'setShowSaveDeliverableModal':
      return { ...state, showSaveDeliverableModal: action.showSaveDeliverableModal };
    case 'setSelectedFolder':
      return { ...state, selectedFolder: action.selectedFolder };
    default:
      throw new Error('Unexpected action');
  }
};

const Tablist = ({
  prop,
  propsChosen,
  tabType,
  price,
  superVal,
  currency,
  tabs,
  config,
  prelist,
  transform,
  onChange,
  editstrategy,
  save,
  saveUser,
  setDelivsRegex,
  setSuperRegex,
  setMilesRegex,
  isWizard,
  action,
  sidebarCollapsed,
  setSidebarCollapsed,
}) => {
  const {
    treeData,
    handleTreeData,
    addKey,
    setIndexes,
    initialTreeData,
    setInitialTreeData,
    getDefaultName,
  } = useTreeHandler();

  const {
    fetchMoreWixProductsAndServices,
    fetchMoreWixProductsAndServicesLoading,
    fetchMorePipedriveProducts,
    fetchMoreHubSpotProducts,
    fetchMorePipedriveProductsLoading,
    fetchMoreHubSpotProductsLoading,
  } = useContext(DraftContext);

  const [state, dispatch] = useReducer(reducer, initialState);
  const [tablistSidebarCollapsed, setTablistSidebarCollapsed] = useState(sidebarCollapsed || true);
  const previousPriceType = useRef(price);
  const previousTabs = useRef(tabs);
  const previousChosen = useRef(propsChosen);
  const prelistRef = useRef(null);

  /**
   * Fetch tree view
   */
  const [fetchTreeView, { loading: loadingTreeView }] = useLazyQuery(GET_TREEVIEW_DATA, {
    fetchPolicy: 'network-only',
    variables: {
      type: 'catalogs',
    },
    onCompleted: ({ fetchContentLibrary }) => {
      let tempTreeData = JSON.parse(JSON.stringify(fetchContentLibrary || {}));
      tempTreeData = setIndexes(tempTreeData);
      handleTreeData({
        data: tempTreeData || {},
        type: 'catalogs',
        fromPriceModal: true,
        isDefaultFolder: !!prelist.find((item) => item.key === 'defaultDeliverables'),
        isWixServices: !!prelist.find((item) => item.key === 'wixServices'),
        isWixProducts: !!prelist.find((item) => item.key === 'wixProducts'),
        isPipedriveProducts: !!prelist.find((item) => item.key === 'pipedriveProducts'),
        isHubSpotProducts: !!prelist.find((item) => item.key === 'hubspotProducts'),
      });
      setInitialTreeData(tempTreeData);
    },
  });

  /**
   * Add child mutation
   */
  const [addChild] = useMutation(CONTENT_LIBRARY_ADD_CHILD, {
    onCompleted() {
      notification.success({
        description: 'Created new folder successfully.',
      });
      fetchTreeView();
    },
  });

  /**
   * Add catalog
   */
  const [addCatalog] = useMutation(CONTENT_LIBRARY_ADD_CATALOG);

  /**
   * Update catalog
   */
  const [updateCatalog] = useMutation(CONTENT_LIBRARY_UPDATE_CATALOG);

  const user = useReactiveVar(userVar);

  const configText = (x, disableTrim) => {
    return helpers.configText({
      x,
      notmarked: true,
      config,
      prop,
      user: user,
      vars: {},
      disableTrim,
    });
  };

  const handleUndo = (e) => {
    if (e.ctrlKey && e.key === 'z' && state.undoOption) {
      dispatch({ type: 'setChosen', chosen: state.undoOption });
      dispatch({ type: 'undoOption', undoOption: null });
    }
  };

  /**
   * Use effect
   */
  useEffect(() => {
    if (fetchMorePipedriveProductsLoading || fetchMoreHubSpotProductsLoading) {
      return;
    }
    fetchTreeView();
  }, [fetchTreeView, fetchMorePipedriveProductsLoading, fetchMoreHubSpotProductsLoading]);

  useEffect(() => {
    document.addEventListener('keydown', handleUndo);
  });

  useEffect(() => {
    const defaultChosen = propsChosen || helpers.getDefaultOptions({ prelist, config, prop });
    // switch if tax is type -1 or the other way
    // datautils.taxdisfix(defaultChosen);

    _.each(defaultChosen, (v) => {
      if (v.discount && !v.discount.type) {
        if (v.discount.val < 0) {
          v.discount.val = Math.abs(v.discount.val);
          v.discount.type = -1;
        } else {
          v.discount.type = 1;
        }
      }
    });

    if (
      JSON.stringify(defaultChosen) !== JSON.stringify(previousChosen) &&
      Object.keys(defaultChosen).length
    ) {
      const stabKeys = Object.keys(defaultChosen);

      dispatch({
        type: 'setStab',
        stab: state.stab && stabKeys.indexOf(state.stab) > -1 ? state.stab : stabKeys[0],
      });
      dispatch({
        type: 'setTotalValue',
        totalValue: defaultChosen[Object.keys(defaultChosen)[0]].total,
      });
    }

    if (
      previousPriceType !== price &&
      previousTabs !== tabs &&
      state.stab &&
      state.chosen &&
      state.chosen[state.stab]
    ) {
      dispatch({
        type: 'setSelectedValue',
        stab: state.chosen[state.stab].type,
      });
    }
  }, [prelist]);

  useEffect(() => {
    if (state.chosen === '' || Object.keys(state.chosen).length === 0 || isWizard) {
      dispatch({ type: 'setChosen', chosen: propsChosen });
    }
  }, [propsChosen]);

  useEffect(() => {
    if (!action) return;

    if (action === 'reset-super-choosen') {
      // applicable only for super section
      state.chosen['OPTION 1'].list = [];
    } else if (action === 'reset-price-choosen') {
      // applicable for price section
      const keys = Object.keys(state.chosen);
      keys.map((key) => {
        state.chosen[key].list = [];
        state.chosen[key].customColumns = [];
      });
    } else if (action === 'reset-miles-choosen') {
      // applicable only for miles section
      state.chosen = {};
    }
  }, [action]);

  useEffect(() => {
    if (typeof sidebarCollapsed === 'boolean') {
      setTablistSidebarCollapsed(sidebarCollapsed);
    }
  }, [sidebarCollapsed]);

  const saveDeliverable = (deliverable, onCompletedCallback) => {
    // Extract price amount - handle both object and primitive cases
    let priceAmount = '0';
    if (
      deliverable?.currentPrice !== undefined &&
      deliverable?.currentPrice !== null &&
      deliverable?.currentPrice !== ''
    ) {
      priceAmount = deliverable.currentPrice;
    } else if (deliverable?.price) {
      // Check if price is an object with amount property
      if (typeof deliverable.price === 'object' && !Array.isArray(deliverable.price)) {
        // Check if it's not an empty object
        if (Object.keys(deliverable.price).length > 0 && deliverable.price.amount !== undefined) {
          priceAmount = deliverable.price.amount;
        }
      } else {
        // Price is a primitive value
        priceAmount = deliverable.price;
      }
    }

    const catalog = {
      name: deliverable.name,
      description: deliverable.description,
      price: {
        amount: String(priceAmount),
        type: deliverable.type,
        items: deliverable?.items || 1,
        quantity: deliverable?.quantity || 1,
      },
      discount: {
        value: deliverable?.discount?.value || '0',
        unit: deliverable?.discount?.unit || '%',
      },
      images: deliverable?.images?.map((thumbnail) => ({
        name: thumbnail.name,
        url: thumbnail.url,
      })),
      folderKey: deliverable.folderKey,
    };

    const onCompleted = () => {
      dispatch({ type: 'setShowSaveDeliverableModal', showSaveDeliverableModal: false });
      if (
        deliverable.folderKey === state.selectedFolder?.key ||
        state.selectedFolder?.key === 'saved-deliverables'
      ) {
        prelistRef?.current?.refetchCatalogs({
          variables: {
            type: 'catalogs',
            key: deliverable.folderKey,
          },
        });
      }
      if (onCompletedCallback) {
        onCompletedCallback();
      }
      notification.success({
        message: `Product ${deliverable._id ? 'updated' : 'saved'} successfully`,
        description: `The product has been ${
          deliverable._id ? 'updated' : 'saved'
        } to the content library.`,
      });
    };

    if (deliverable._id) {
      updateCatalog({
        variables: {
          id: deliverable._id,
          catalog,
        },
        onCompleted: () => onCompleted(),
      });
    } else {
      addCatalog({
        variables: {
          catalog,
        },
        onCompleted: () => onCompleted(),
      });
    }
  };

  const handleSidebarCollapsed = (value) => {
    setTablistSidebarCollapsed(value);
    if (setSidebarCollapsed) {
      setSidebarCollapsed(value);
    }
  };

  const listChanged = (t, list) => {
    const chosen = _.merge({}, state.chosen);
    chosen[t].list = list;

    onChange(chosen);
    dispatch({ type: 'setChosen', chosen });
  };

  const handleState = (type, value, typeValue) => {
    switch (type) {
      case 'delivs':
        setDelivsRegex(value);
        break;
      case 'miles':
        setMilesRegex(value);
        break;
      case 'super':
        setSuperRegex(value);
        break;
      case 'currencies':
        break;
      default:
        return;
    }

    if (typeValue) {
      const userConfig = JSON.parse(JSON.stringify(user.config)) || {};
      let newValue;

      if (type === 'super') {
        newValue = userConfig && userConfig[type] ? userConfig[type] : {};

        newValue[typeValue?.replace(/\./g, '')] = {
          name: typeValue,
          editable: true,
        };
      } else if (type === 'currencies') {
        newValue = userConfig?.currencies || [];

        // remove or add
        if (value === 'remove') {
          // typeValue is array
          newValue = newValue.filter((item) => !typeValue.includes(item));
        } else {
          const isExists = newValue.some((item) => item === typeValue);
          if (isExists) return;

          newValue.push(typeValue);
        }
      } else {
        newValue = userConfig && userConfig[type] ? userConfig[type] : [];
        if (!newValue.find((newVal) => newVal.name === typeValue))
          newValue.push({ name: typeValue, editable: true });
      }

      userConfig[type] = newValue;

      saveUser({
        variables: {
          user: {
            id: user._id,
            config: userConfig,
          },
        },
      });
    }
  };

  const calcDiscPrice = (price, discount, symbol, isDotSeparator) => {
    if (isDotSeparator) {
      discount = Number(String(discount).replaceAll(',', '.'));
      price = Number(String(price).replaceAll(',', '.'));
    }
    if (discount && price) {
      if (symbol === '%') {
        if (discount >= 100) {
          if (discount > 100) return price;
        }
        price = price - price * (discount / 100);
      } else {
        price = price - discount;
      }
    }
    return price;
  };

  const addItem = ({ name, description, price, type, text, images, discount, items, quantity }) => {
    return (notFromList, tempChosen) => {
      if (name) {
        let chosen = _.merge({}, tempChosen);
        if (superVal && notFromList === true) {
          chosen[state.stab].list.push({
            id: uuidv4(),
            name: name,
            super: { text: name, type: null },
          });
        } else if (chosen[state.stab]) {
          let subTotal = price;

          if (discount && discount.value) {
            if (Number(discount.value) > price && discount.unit !== '%') {
              discount.value = price;
            } else if (Number(discount.value) > 100 && discount.unit === '%') {
              discount.value = 0;
            }

            subTotal = calcDiscPrice(
              price,
              discount.value,
              discount.unit,
              prop.priceSeperator === '.'
            );
          }

          chosen[state.stab].list.push({
            id: uuidv4(),
            name: name,
            ...(description ? { description } : {}),
            ...(price ? { price: subTotal } : {}),
            ...(subTotal ? { currentPrice: price } : {}),
            ...(type ? { type: type } : {}),
            ...(text ? { text } : {}),
            ...(images ? { images } : {}),
            ...(discount && discount.value
              ? {
                  discount: { unit: discount.unit === '%' ? '%' : currency, value: discount.value },
                }
              : {}),
            ...(items ? { items: items || 1 } : {}),
            ...(quantity ? { quantity: quantity || 1 } : {}),
          });
        } else if (!Object.keys(chosen).length) {
          let subTotal = price;

          if (discount && discount.value) {
            if (Number(discount.value) > price && discount.unit !== '%') {
              discount.value = price;
            } else if (Number(discount.value) > price && discount.unit === '%') {
              discount.value = 0;
            }

            subTotal = calcDiscPrice(
              price,
              discount.value,
              discount.unit,
              prop.priceSeperator === '.'
            );
          }
          chosen = {
            [state.stab]: {
              total: '',
              list: [
                {
                  id: uuidv4(),
                  name: name,
                  ...(description ? { description } : {}),
                  ...(price ? { price: subTotal } : {}),
                  ...(subTotal ? { currentPrice: price } : {}),
                  ...(type ? { type: type } : {}),
                  ...(text ? { text } : {}),
                  ...(images ? { images } : {}),
                  ...(discount && discount.value
                    ? {
                        discount: {
                          unit: discount.unit === '%' ? '%' : currency,
                          value: discount.value,
                        },
                      }
                    : {}),
                  ...(items ? { items: items || 1 } : {}),
                  ...(quantity ? { quantity: quantity || 1 } : {}),
                },
              ],
            },
          };
        }

        const customColumnsValuesToBePushed = Math.abs(
          (chosen[state.stab]?.customColumns?.[0]?.values?.length || 0) -
            chosen[state.stab]?.list?.length
        );

        if (customColumnsValuesToBePushed) {
          for (let i = 0; i < customColumnsValuesToBePushed; i++) {
            chosen[state.stab]?.customColumns?.map((column) => {
              column.values.push('');
            });
          }
        }

        onChange(chosen);
        dispatch({ type: 'setChosen', chosen });
      }
    };
  };

  const removeItem = (name) => {
    if (!name) return;
    const userConfig = JSON.parse(JSON.stringify(user.config));
    let newValue;

    if (tabType === 'super') {
      newValue = userConfig && userConfig[tabType] ? userConfig[tabType] : {};
      delete newValue[name];
    } else {
      newValue = userConfig && userConfig[tabType] ? userConfig[tabType] : [];
      newValue = newValue.filter((value) => value.name !== name);
    }

    userConfig[tabType] = newValue;
    saveUser({
      variables: {
        user: {
          id: user._id,
          config: userConfig,
        },
      },
    });
  };

  const addNewItem = (value) => {
    addItem({ name: value })(true, state.chosen);
    handleState(tabType, '', value);
  };

  // Check if proposal has an active integration: Wix, Pipedrive, or HubSpot
  const haveActiveIntegrations =
    !!prop?.wixConnectedInstance || !!prop?.pipedriveDealId || !!prop?.hubspot?.hubspotDealId;

  return (
    <Row
      gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
      className={`tablist-container ${tablistSidebarCollapsed ? 'inactive' : 'active'} ${
        tabType || 'super'
      }`}>
      <div className="ant-modal-mask" onClick={() => handleSidebarCollapsed(true)} />
      <ContentLibraryProvider
        fetchTreeView={fetchTreeView}
        loadingTreeView={loadingTreeView}
        initialTreeData={initialTreeData}
        addKey={addKey}
        setIndexes={setIndexes}
        handleTreeData={handleTreeData}
        handleTreeSearch={handleTreeSearch}
        handleModalTreeSearch={handleModalTreeSearch}
        filterTreeData={filterTreeData}
        treeData={treeData}
        handleRefetch={fetchTreeView}
        getDefaultName={getDefaultName}
        saveDeliverable={saveDeliverable}
        addChild={addChild}>
        <Col
          className={`tablist-prelist-container ${
            state.collapse ? 'tablist-prelist-container-collapsed' : ''
          }`}>
          {fetchMoreHubSpotProductsLoading || fetchMorePipedriveProductsLoading ? (
            <Loader />
          ) : (
            <Prelist
              ref={prelistRef}
              language={prop.language}
              prelist={JSON.parse(JSON.stringify(prelist))}
              chosen={state.chosen}
              tabType={tabType}
              addItem={addItem}
              removeItem={removeItem}
              addNewItem={addNewItem}
              handleState={handleState}
              collapse={state.collapse}
              setCollapse={(collapse) => dispatch({ type: 'setCollapse', collapse })}
              wixConnectedInstance={prop.wixConnectedInstance}
              haveActiveIntegrations={haveActiveIntegrations}
              fetchMoreWixProductsAndServicesLoading={fetchMoreWixProductsAndServicesLoading}
              fetchMoreWixProductsAndServices={fetchMoreWixProductsAndServices}
              fetchMorePipedriveProductsLoading={fetchMorePipedriveProductsLoading}
              fetchMorePipedriveProducts={fetchMorePipedriveProducts}
              fetchMoreHubSpotProductsLoading={fetchMoreHubSpotProductsLoading}
              fetchMoreHubSpotProducts={fetchMoreHubSpotProducts}
              selectedFolder={state.selectedFolder}
              setSelectedFolder={(selectedFolder) =>
                dispatch({ type: 'setSelectedFolder', selectedFolder })
              }
            />
          )}
        </Col>
        <ChoosenTotals
          isWizard={isWizard}
          currency={currency}
          state={state}
          dispatch={(dispatchOptions) => {
            if (dispatchOptions.type === 'setChosen')
              onChange(dispatchOptions.chosen, dispatchOptions.orderSave);
            dispatch(dispatchOptions);
          }}
          chosen={state.chosen}
          transform={transform}
          tabType={tabType}
          price={price}
          editstrategy={editstrategy}
          tabs={tabs}
          save={save}
          configText={configText}
          listChanged={listChanged}
          prop={prop}
          handleState={handleState}
          saveUser={saveUser}
          collapse={state.collapse}
          setCollapse={(collapse) => dispatch({ type: 'setCollapse', collapse })}
          setSidebarCollapsed={setSidebarCollapsed}
          setShowSaveDeliverableModal={(showSaveDeliverableModal) =>
            dispatch({
              type: 'setShowSaveDeliverableModal',
              showSaveDeliverableModal: showSaveDeliverableModal,
            })
          }
          showSaveDeliverableModal={state.showSaveDeliverableModal}
          calcDiscPrice={calcDiscPrice}
        />
      </ContentLibraryProvider>
    </Row>
  );
};

Tablist.defaultProps = {
  propsChosen: '',
  tabs: false,
  editstrategy: '',
  currency: '',
  save: () => {},
  setDelivsRegex: () => {},
  setSuperRegex: () => {},
  setMilesRegex: () => {},
  superVal: false,
  price: false,
  transform: () => {},
  isWizard: false,
  action: '',
  sidebarCollapsed: true,
  setSidebarCollapsed: () => {},
};

Tablist.propTypes = {
  prop: PropTypes.instanceOf(Object).isRequired,
  propsChosen: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  price: PropTypes.bool,
  tabs: PropTypes.bool,
  config: PropTypes.instanceOf(Object).isRequired,
  prelist: PropTypes.instanceOf(Array).isRequired,
  transform: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  tabType: PropTypes.string.isRequired,
  editstrategy: PropTypes.string,
  currency: PropTypes.string,
  save: PropTypes.func,
  setDelivsRegex: PropTypes.func,
  setSuperRegex: PropTypes.func,
  setMilesRegex: PropTypes.func,
  superVal: PropTypes.bool,
  isWizard: PropTypes.bool,
  action: PropTypes.string,
  sidebarCollapsed: PropTypes.bool,
  setSidebarCollapsed: PropTypes.func,
};

export default Tablist;
